export default __webpack_public_path__ + "static/media/click1.07cda4b8.wav";